import {AlpineComponent} from 'alpinejs';

type AudioData = {
  initAudioPlayer: () => void,
  dataUid: string,
}

export default (dataUid: any): AlpineComponent<AudioData> => ({
  dataUid,
  init() {
    this.initAudioPlayer();
  },
  initAudioPlayer() {
    // player based on: https://github.com/greghub/green-audio-player
    const audioPlayer = document.querySelector('#' + dataUid);
    const playPauseBtn = audioPlayer ?
      audioPlayer.querySelector<HTMLElement>('.ce-audio-player-play') : false;
    const progress = audioPlayer ?
      audioPlayer.querySelector<HTMLElement>('.ce-audio-player-controls-slider-progress') : false;
    const volumeBtn = audioPlayer ?
      audioPlayer.querySelector<HTMLElement>('.ce-audio-player-volume') : false;
    const player = audioPlayer ?
      audioPlayer.querySelector<HTMLAudioElement>('audio') : false;
    if (!progress || !playPauseBtn || !player) {
      return;
    }

    const togglePlay = () => {
      if (player.paused) {
        if (playPauseBtn.classList.contains('paused')) {
          playPauseBtn.classList.remove('paused');
        }
        playPauseBtn.classList.add('play');
        player.play();
      } else {
        if (playPauseBtn.classList.contains('play')) {
          playPauseBtn.classList.remove('play');
        }
        playPauseBtn.classList.add('paused');
        player.pause();
      }
    };

    const updateProgress = () => {
      const current = player.currentTime;
      const percent = (current / player.duration) * 100;
      progress.style.width = percent + '%';
    };

    playPauseBtn ? playPauseBtn.addEventListener('click', togglePlay) : false;
    player.addEventListener('timeupdate', updateProgress);
    player.addEventListener('ended', function () {
      if (playPauseBtn) {
        if (playPauseBtn.classList.contains('play')) {
          playPauseBtn.classList.remove('play');
        }
        playPauseBtn.classList.add('paused');
      }
      player.currentTime = 0;
    });

    if (volumeBtn) {
      volumeBtn.addEventListener('click', () => {
        volumeBtn.classList.toggle('muted');
        player.muted = !player.muted;
      });
    }
  }
});
